import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from "highcharts";

@Component({
  selector: 'app-generic-graph',
  templateUrl: './generic-graph.component.html',
  styleUrls: ['./generic-graph.component.scss']
})
export class GenericGraphComponent implements OnInit {

  public Highcharts: typeof Highcharts = Highcharts;

  @Input() chartType: string = 'column';
  @Input() dataType: string = 'datetime';
  @Input() name: string;
  @Input() height = 225;
  @Input() title = '';
  @Input() dataDescription: string = null;
  @Input() tooltipDecimalPlaces: number = 0;
  @Input() customSeries: boolean = false;
  @Input() legend: boolean = false;
  @Input() plotOptions: any = {};

  _data: any[];

  public chartOptions;
  public chart;

  constructor() { }

  ngOnInit(): void {
    this.setOptions();
    this.buildGraph();
  }

  @Input()
  public set data(data: any[]) {
    this._data = data;
    this.buildGraph();
  }

  public hcCallback(chart: Highcharts.Chart) { this.chart = chart; }

  public getCallbackWithContext() { return (chart: Highcharts.Chart) => this.hcCallback(chart); }

  private buildGraph(): void {
    this.chartOptions = {
      chart: {
        type: this.chartType,
        height: this.height,
        zoomType: 'x',
        resetZoomButton: {
          position: {
            x: 0,
            y: 160
          }
        }
      },
      plotOptions: this.plotOptions,
      title: {
        text: this.title
      },
      xAxis: {
        type: this.dataType
      },
      yAxis: {
        title: {
          enabled: false
        }
      },
      legend: {
        enabled: this.legend
      },
      tooltip: {
        valueDecimals: this.tooltipDecimalPlaces
      },
      credits: {
        enabled: false
      }
    };

    if(this.customSeries) {
      this.chartOptions.series = this._data;
    } else {
      this.chartOptions.series = [{name: this.name, data: this._data}];
    }
  }

  private setOptions() {
    Highcharts.setOptions({
      lang: {
        loading: 'Cargando...',
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        rangeSelectorFrom: "Desde",
        rangeSelectorTo: "Hasta",
        rangeSelectorZoom: "Período",
        downloadPNG: 'Descargar imagen PNG',
        downloadJPEG: 'Descargar imagen JPEG',
        downloadPDF: 'Descargar imagen PDF',
        downloadSVG: 'Descargar imagen SVG',
        printChart: 'Imprimir',
        resetZoom: 'Reiniciar zoom',
        resetZoomTitle: 'Reiniciar zoom',
        thousandsSep: ".",
        decimalPoint: ','
      }
    });
  }
}
